import React from "react";

type LoadingTableProps = {
  headers: string[]; // e.g. ["", "Service", "Price"]
  rows?: number;     // default: 5
  className?: string;
};

export default function LoadingTable({
  headers,
  rows = 5,
  className = "",
}: LoadingTableProps) {
  const getCellWidth = (colIndex: number, rowIndex: number) => {
    // simple width variety
    if (colIndex === 0) return "w-6"; // icon column
    if (colIndex === headers.length - 1) {
      // price column tends to be shorter
      return rowIndex % 2 === 0 ? "w-20" : "w-24";
    }
    // main text column(s)
    const variants = ["w-3/4", "w-2/3", "w-4/5", "w-1/2"];
    return variants[(rowIndex + colIndex) % variants.length];
  };

  const CellSkeleton = ({ colIndex, rowIndex }: { colIndex: number; rowIndex: number }) => (
    <div className="animate-pulse">
      <div className={`h-2 bg-gray-200 rounded-full ${getCellWidth(colIndex, rowIndex)}`} />
    </div>
  );

  return (
    <table className={`divide-y border divide-gray-300 w-full ${className}`}>
      <thead>
        <tr className="bg-primary-50 text-gray-800">
          {headers.map((h, i) => (
            <th
              key={i}
              className="py-1.5 px-2 text-sm font-semibold lg:table-cell text-left"
            >
              {h}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {Array.from({ length: Math.max(0, rows) }).map((_, r) => (
          <tr key={r} className="hover:bg-gray-50">
            {headers.map((_, c) => (
              <td key={c} className="px-3 py-1.5 border text-sm">
                <CellSkeleton colIndex={c} rowIndex={r} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
